var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:'value' + (_vm.items.length > 0 ? ` ${_vm.notEmptyClass}` : '')},[(_vm.items.length === 0)?_c('span',[_vm._v("0")]):_vm._e(),_vm._l((_vm.items),function(item){return _c('span',{key:item.currency,staticClass:"d-block w-100"},[_vm._v(" "+_vm._s(item.sum)+" "+_vm._s(_vm.$currencySymbol(item.currency))+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }